module.exports = __webpack_public_path__ + "static/media/csu.1931adea.png";